import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

class NoConfiguradoNoRc extends React.PureComponent<{ configurado: boolean }> {
    render() {
        return (
            this.props.configurado ? null :
                <div className="alert alert-danger">
                    <h3>
                        <i className={fa("ban")} />
                        <label>
                            Sistema no configurado
                    </label>
                    </h3>
                    El sistema no esta configurado por lo que no funcionará correctamente.
                    <kea.Link onClick={() => history.go("/configuracion")} iconClass={fa("gear")} >
                        Configurar sistema
                    </kea.Link>
                </div>
        )
    }
}

const configurado = observeResource(resources.ConfigSistema.EstaConfigurado);
export const NoConfigurado = kea.defaultProps(componentToRx(NoConfiguradoNoRc), { configurado: configurado } );


// WEBPACK FOOTER //
// ./app/features/componentes/configurado.tsx